import { Component } from '@angular/core';

@Component({ standalone: false, selector: 'app-grid-page-template',
  templateUrl: './grid-page-template.component.html',
  styleUrls: ['./grid-page-template.component.scss']
})
export class GridPageTemplateComponent {
}
